import { routerGetCall } from '../../axios';

const getMaturedPension = (state, params) => {
  const url = `/accounts/maturedPensionDetails`;
  return routerGetCall(state, url, params);
};

export default { getMaturedPension };
